import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function HomeBanner({ homePageData }) {
    const { i18n } = useTranslation();

    if (!homePageData || !homePageData.banner || homePageData.banner.length === 0) {
        return null;
    }

    const getLocalizedData = () => {
        const lang = i18n.language;

        if (lang === 'ru' && homePageData.ru_banner && homePageData.ru_banner.length > 0) {
            return homePageData.ru_banner[0];
        }

        if (lang === 'hy' && homePageData.arm_banner && homePageData.arm_banner.length > 0) {
            return homePageData.arm_banner[0];
        }

        return homePageData.banner[0];
    };

    const banner = getLocalizedData();

    return (
        <section
            className="py-36 lg:py-56 w-full relative bg-top bg-no-repeat"
            id="home"
            style={{
                backgroundImage: `url(${banner.img || '../../assets/images/bg/bg1.jpg'})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>

            <div className="container relative z-10 flex flex-col items-start justify-center min-h-[50vh]">
                <h3 className="font-medium leading-normal text-4xl mb-5 text-white max-w-3xl">
                    {banner.title || "We're Helping to Achieve your Success."}
                </h3>

                <div
                    className="text-white text-lg mb-6 max-w-2xl text-left"
                    dangerouslySetInnerHTML={{
                        __html:
                            banner.description ||
                            "This is just a simple text made for this unique and awesome template, you can replace it with any text.",
                    }}
                />

                <div className="mt-2">
                    <Link
                        to={banner.btnLink || "#"}
                        className="py-2 px-5 inline-block font-normal tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-white-600 hover:bg-white-700 border-white-600 hover:border-white-700 text-black rounded-md"
                    >
                        {banner.btnName || "Learn More"}
                    </Link>
                </div>
            </div>
        </section>

    );
}

export default HomeBanner;